var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBackToTop)?_c('button',{staticClass:"fixed bottom-8 right-8 w-12 h-12 rounded-full bg-blue-600 hover:bg-blue-700 text-white flex items-center justify-center shadow-lg transition-all duration-300",attrs:{"id":"backToTop"},on:{"click":_vm.backToTop}},[_c('i',{staticClass:"fas fa-arrow-up"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }